import Resource from './resource';

export default class LoginResource extends Resource{
	constructor(){
		super('oauth2');
	}
}